module.exports = __webpack_public_path__ + "static/media/11.cdfac50f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/11.svg
// module id = 2802
// module chunks = 3